
// following is the full list of domain tlds
// currently we are only restricting it to tlds already shown in logodesign.net
// ["com", "co", "ca", "co.uk", "org", "io", "net", "us", "me", "info", "site", "store"]
export const tlds = ["com", "net", "org", "info", "biz", "me"]

export function getProjectCss() {
    require('../styles/main.css')
    if (process.env.REACT_APP_NAME === "FLC") {
        require('../styles/flc.css')
    }
    if (process.env.REACT_APP_NAME === "LD") {
        require('../styles/ld.css')
    }
    if (process.env.REACT_APP_INCLUDE_BOOTSTRAP === "true") {
        require('bootstrap/dist/css/bootstrap.min.css')
    }
}

export function sanitizeDomain(name: string) {
    name = name.toLowerCase()
    name = name.replaceAll(/[^a-zA-Z &]/g, '')
    name = name.replaceAll('&', 'and')
    name = name.replaceAll(' ', '')
    return name
}

export function generateDomains(name: string) {    
    return tlds.map((item) => {
        return `${name}.${item}`
    })
}

export function shuffleArray<T>(array: T[]): T[] {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }

    return array;
}

export function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function uniquify<T>(input: T[]): T[] {
    const uniqueValues: { [key: string]: boolean } = {};
    return input.filter((value: T) => {
        if (!uniqueValues.hasOwnProperty(String(value))) {
            uniqueValues[String(value)] = true;
            return true;
        }
        return false;
    });
}

export function redirectToBuyDomain(domainName: string) {
    const APP_NAME = process.env.REACT_APP_NAME
    const BASE_URL = process.env.REACT_APP_BASE_URL

    // TODO: handle for FLC

    if (APP_NAME === "LD") {
        window.open(`${BASE_URL}/user/web/get-domain?domainName=${domainName}&id=null`)
    }
}